// EU 27 — shared across CountryStrip, Header dropdown, and CountryDetail.
// `name` is the canonical English name; `name_it` is the Italian display
// label. UI components pick the right one via the `localizeCountryName`
// helper depending on the active i18n language.
export const EU_COUNTRIES = [
  { name: "Austria", name_it: "Austria", code: "at", slug: "austria" },
  { name: "Belgium", name_it: "Belgio", code: "be", slug: "belgium" },
  { name: "Bulgaria", name_it: "Bulgaria", code: "bg", slug: "bulgaria" },
  { name: "Croatia", name_it: "Croazia", code: "hr", slug: "croatia" },
  { name: "Cyprus", name_it: "Cipro", code: "cy", slug: "cyprus" },
  { name: "Czech Republic", name_it: "Repubblica Ceca", code: "cz", slug: "czech-republic" },
  { name: "Denmark", name_it: "Danimarca", code: "dk", slug: "denmark" },
  { name: "Estonia", name_it: "Estonia", code: "ee", slug: "estonia" },
  { name: "Finland", name_it: "Finlandia", code: "fi", slug: "finland" },
  { name: "France", name_it: "Francia", code: "fr", slug: "france" },
  { name: "Germany", name_it: "Germania", code: "de", slug: "germany" },
  { name: "Greece", name_it: "Grecia", code: "gr", slug: "greece" },
  { name: "Hungary", name_it: "Ungheria", code: "hu", slug: "hungary" },
  { name: "Ireland", name_it: "Irlanda", code: "ie", slug: "ireland" },
  { name: "Italy", name_it: "Italia", code: "it", slug: "italy" },
  { name: "Latvia", name_it: "Lettonia", code: "lv", slug: "latvia" },
  { name: "Lithuania", name_it: "Lituania", code: "lt", slug: "lithuania" },
  { name: "Luxembourg", name_it: "Lussemburgo", code: "lu", slug: "luxembourg" },
  { name: "Malta", name_it: "Malta", code: "mt", slug: "malta" },
  { name: "Netherlands", name_it: "Paesi Bassi", code: "nl", slug: "netherlands" },
  { name: "Poland", name_it: "Polonia", code: "pl", slug: "poland" },
  { name: "Portugal", name_it: "Portogallo", code: "pt", slug: "portugal" },
  { name: "Romania", name_it: "Romania", code: "ro", slug: "romania" },
  { name: "Slovakia", name_it: "Slovacchia", code: "sk", slug: "slovakia" },
  { name: "Slovenia", name_it: "Slovenia", code: "si", slug: "slovenia" },
  { name: "Spain", name_it: "Spagna", code: "es", slug: "spain" },
  { name: "Sweden", name_it: "Svezia", code: "se", slug: "sweden" },
];

export function localizeCountryName(country, lang = "it") {
  if (!country) return "";
  return lang === "it" && country.name_it ? country.name_it : country.name;
}
